import { DeviceConfigParams } from "../../DeviceConfigParams";
export class Rck21ConfigParams extends DeviceConfigParams {
    constructor() {
        super(...arguments);
        this.ReedSwitchMode = ReedSwitchOperationMode.ShortingOnOpeningOff;
        this.SyncTime = 720;
        this.LogicNegation = false;
    }
}
/**
 * Hall state configuration
 */
export var ReedSwitchOperationMode;
(function (ReedSwitchOperationMode) {
    ReedSwitchOperationMode[ReedSwitchOperationMode["TimeConditionMode"] = 1] = "TimeConditionMode";
    ReedSwitchOperationMode[ReedSwitchOperationMode["ShortingSwitchOpeningNoResp"] = 2] = "ShortingSwitchOpeningNoResp";
    ReedSwitchOperationMode[ReedSwitchOperationMode["ShortingOnOpeningOff"] = 3] = "ShortingOnOpeningOff";
    ReedSwitchOperationMode[ReedSwitchOperationMode["ShortingOffOpeningOn"] = 4] = "ShortingOffOpeningOn";
    ReedSwitchOperationMode[ReedSwitchOperationMode["ShortingOnOpeningNoResp"] = 5] = "ShortingOnOpeningNoResp";
    ReedSwitchOperationMode[ReedSwitchOperationMode["ShortingOffOpeningNoResp"] = 6] = "ShortingOffOpeningNoResp";
    ReedSwitchOperationMode[ReedSwitchOperationMode["ShortingNoRespOpeningOn"] = 7] = "ShortingNoRespOpeningOn";
    ReedSwitchOperationMode[ReedSwitchOperationMode["ShortingNoRespOpeningOff"] = 8] = "ShortingNoRespOpeningOff";
    ReedSwitchOperationMode[ReedSwitchOperationMode["ShortingNoRespOpeningSwitch"] = 9] = "ShortingNoRespOpeningSwitch";
    ReedSwitchOperationMode[ReedSwitchOperationMode["RevertTimeConditionMode"] = 10] = "RevertTimeConditionMode";
})(ReedSwitchOperationMode || (ReedSwitchOperationMode = {}));
//# sourceMappingURL=Rck21ConfigParams.js.map